module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/035-luxembourg-2db1b52cb930b859b448a6af2f4ec66a.svg";